import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo, useCallback } from 'react';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from "../../../hooks/useGetDimensionGroup";
import { Text } from "../../../Text";
import { Link } from "../../../Link";
import { ChevronLeftIcon } from "../../../icons";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var HeaderBar = /*#__PURE__*/memo(function (_ref) {
  var backButtonText = _ref.backButtonText,
    backButtonClick = _ref.backButtonClick,
    _ref$backButtonHref = _ref.backButtonHref,
    backButtonHref = _ref$backButtonHref === void 0 ? '#' : _ref$backButtonHref,
    headerText = _ref.headerText,
    size = _ref.size,
    isLoading = _ref.isLoading,
    isNoPadding = _ref.isNoPadding,
    subtitleText = _ref.subtitleText,
    isCloseButtonVisible = _ref.isCloseButtonVisible;
  var isMobile = useIsMobileDimension();
  var handleClick = useCallback(function (event) {
    if (backButtonHref === '#') {
      event.preventDefault();
    }
    if (backButtonClick) {
      backButtonClick();
    }
  }, [backButtonHref, backButtonClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('header-bar', {
      'header-bar--no-padding': isNoPadding,
      'header-bar--alone': !headerText && !subtitleText && !backButtonText && !isCloseButtonVisible
    })
  }, !isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, backButtonText && /*#__PURE__*/React.createElement("div", {
    className: cn('header-bar__back-button', _defineProperty({}, "header-bar__back-button--".concat(size), !!size))
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textIconElementSecondary",
    size: "size5-r-s",
    tagType: "div"
  }, /*#__PURE__*/React.createElement(Link, {
    href: backButtonHref,
    icon: /*#__PURE__*/React.createElement(ChevronLeftIcon, {
      fill: "#5a5e62",
      size: isMobile ? 24 : 32
    }),
    isNoUnderline: true,
    onClick: handleClick
  }, backButtonText))), headerText && /*#__PURE__*/React.createElement("div", {
    className: cn('header-bar__header', {
      'header-bar__header--no-back-button': !backButtonText,
      'header-bar__header--back-button': backButtonText,
      'header-bar__header--multiple': subtitleText
    })
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size2-m"
  }, headerText)), subtitleText && /*#__PURE__*/React.createElement("div", {
    className: cn('header-bar__subtitle')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textIconElementSecondary",
    size: "size4-r"
  }, subtitleText))));
});